module.exports = __webpack_public_path__ + "img/studytube.ff77127b.png";